import { APIGenerator } from "../../../utils/genericAPI/GenerateAPI";
import { Organization, OrganizationPatch } from "../types/organization.types";

export const BASE_URL_ORGANIZATION =
  process.env.REACT_APP_BACKEND_API_URL + "/api/v1/organizations";

  export const organizationAPI = new APIGenerator<Organization, OrganizationPatch, OrganizationPatch>(BASE_URL_ORGANIZATION)